import React from 'react'
import { useTranslation } from 'react-i18next'
import { TitleBar } from '../../../components/TitleBar'

interface NewsTitleBarProps {
  isAdmin: boolean
  onAddClick: () => void
}

function NewsTitleBar({ isAdmin, onAddClick }: Readonly<NewsTitleBarProps>) {
  const { t } = useTranslation()

  return (
    <TitleBar title={t('pages.page', { context: 'news' })} isMobileThin>
      <div className="d-flex justify-content-end align-items-center ps-3 w-100">
        {isAdmin && (
          <button
            type="button"
            className="btn btn-secondary btn-lg d-flex align-items-center text-primary shadow-sm"
            onClick={onAddClick}
            data-testid="news-add"
          >
            <i className="far fa-plus me-2" />
            <span>{t('buttons.addNew')}</span>
          </button>
        )}
      </div>
    </TitleBar>
  )
}

export default NewsTitleBar
